<blaze-scroller class="h-full p-16 w-full">
  <h1 class="menu-title">Data Connectors</h1>

  <div class="menu-items">
    <div class="search">
      <blaze-filter-input
        (filtered)="setFiltered($event)"
        [items$]="[configured$, templates$, tables$]"
        [placeholder]="'Search data connectors'"
        class="searchbox"
      />
    </div>

    <div class="mt-16 connector-tabs">
      <mat-tab-group #tabs dynamicHeight disablePagination animationDuration="0ms">
        <!-- Configured Connectors -->
        <mat-tab
          [ngClass]="'tab-configured'"
          bodyClass="tab-body-configured"
          class="tab-content"
          label="Configured"
        >
          <blaze-connector-menu-item
            (create)="openCreateTableDialog()"
            (editConnector)="openEditTableDialog($event.table)"
            (previewDataset)="openPreviewTableDialog($event.table)"
            (refreshDatasets)="refreshTables()"
            [page]="pages.Configured"
            [projectGroupId]="projectGroupId()"
            [tableConnector]="{ tables, name: 'Blaze Table' }"
          />

          @for (linkedTable of linkedTables; track trackByIdOrName($index, linkedTable)) {
            <blaze-connector-menu-item
              (create)="openCreateLinkedTableDialog()"
              (editConnector)="openEditLinkedTableDialog($event.linkedTableConnector, $event.table)"
              (previewDataset)="openPreviewLinkedTableDialog($event.linkedTableConnector)"
              (refreshDatasets)="refreshTables()"
              [linkedTableConnector]="linkedTable"
              [page]="pages.Configured"
              [projectGroupId]="projectGroupId()"
              [projectId]="projectId"
            />
          }

          @for (item of connectors; track trackByIdOrName($index, item)) {
            <blaze-connector-menu-item
              (create)="openCreateConnectorDialog(item.templateId, item)"
              (editConnector)="openEditConnectorDialog(item.id)"
              (editDatasets)="openEditConnectorDialog(item.id, 'editDatasets')"
              (previewDataset)="openPreviewDialog($event)"
              [connector]="item"
              [page]="pages.Configured"
              [projectGroupId]="projectGroupId()"
            />
          }
        </mat-tab>

        <!-- Available Connector templates -->
        <mat-tab class="tab-content" label="Add New" bodyClass="tab-body-add-new">
          <!-- Blaze Tables -->
          <blaze-connector-menu-item
            (create)="openCreateTableDialog()"
            (editConnector)="openEditTableDialog($event.table)"
            (previewDataset)="openPreviewTableDialog($event.table)"
            [page]="pages.AddNew"
            [projectGroupId]="projectGroupId()"
            [tableConnector]="{ tables, name: 'Blaze Table' }"
          />

          <!-- Linked Blaze Tables -->
          @if (!projectGroupId()) {
            <blaze-connector-menu-item
              (create)="openCreateLinkedTableDialog()"
              [linkedTableConnector]="DEFAULT_LINKED_BLAZE_TABLE_CONNECTOR"
              [page]="pages.AddNew"
              [projectGroupId]="projectGroupId()"
              [projectId]="projectId"
            />
          }

          <!-- Rest Api -->
          <blaze-connector-menu-item
            (create)="openCreateConnectorDialog(REST_API_CONNECTOR_TEMPLATE.id)"
            [page]="pages.AddNew"
            [projectGroupId]="projectGroupId()"
            [template]="REST_API_CONNECTOR_TEMPLATE"
          />

          @for (item of menuItems; track $index) {
            @if (item['target'] && !item['name']) {
              <blaze-connector-menu-item
                (create)="openCreateConnectorDialog(item.id)"
                (previewDataset)="openPreviewDialog($event)"
                [page]="pages.AddNew"
                [projectGroupId]="projectGroupId()"
                [template]="item"
              />
            }
          }
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</blaze-scroller>
